import strings from '@i18n/index';
import * as SC from '@components/modal/settings/settings.style';
import useTheme from '@stores/themeStore';
import { ThemeDark, ThemeLight } from '@assets/icons';

// ThemeDark,
// ThemeLight,

const Theme = () => {
  const { theme, changeTheme } = useTheme();
  return (
    <SC.Wrapper>
      <SC.Title>{strings.SETTINGS__THEME}</SC.Title>
      <SC.ThemeCard htmlFor="light">
        <SC.ThemeCardTitleWrapper>
          <SC.HiddenInput
            type="radio"
            id="light"
            value="light"
            name="theme"
            checked={theme === 'light'}
            onChange={(e) => {
              changeTheme(e.target.value as 'light');
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__LIGHT_THEME}</SC.ThemeCardTitle>
        </SC.ThemeCardTitleWrapper>
        <SC.ThemeImgWrapper>
          <ThemeLight />
        </SC.ThemeImgWrapper>
      </SC.ThemeCard>
      <SC.ThemeCard htmlFor="dark" style={{ marginTop: '16px' }}>
        <SC.ThemeCardTitleWrapper>
          <SC.HiddenInput
            type="radio"
            id="dark"
            value="dark"
            name="theme"
            checked={theme === 'dark'}
            onChange={(e) => {
              changeTheme(e.target.value as 'dark');
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__DARK_THEME}</SC.ThemeCardTitle>
        </SC.ThemeCardTitleWrapper>
        <SC.ThemeImgWrapper>
          <ThemeDark />
        </SC.ThemeImgWrapper>
      </SC.ThemeCard>
    </SC.Wrapper>
  );
};

export default Theme;
